export default {
  'createbusinessprofile.createbusinessprofile': 'Geschäftsprofil erstellen',
};
